import { render, staticRenderFns } from "./DlvN_Invoice.vue?vue&type=template&id=1a5df8ae"
import script from "./DlvN_Invoice.vue?vue&type=script&lang=js"
export * from "./DlvN_Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports